export default {
  downtimeUrl: "https://pl.kodland.com",
  startPage: {
    image: "/welcome/quiz_student_with_parent.jpeg",
    title: "Zdobądź zaproszenie na BEZPŁATNĄ lekcję w 1 minutę",
    button: "Zaczynajmy",
  },
  successPage: {
    title: "Wybierz datę i godzinę, aby otrzymać lekcję ZA DARMO",
    subtitle: "Kliknij przycisk “📆 Zarezerwować lekcję“, aby dokończyć rejestrację.",
    button: "📆 Zarezerwować lekcję",
  },
  quizRotateBySteps: {
    1: {
      question: "Jaki jest ulubiony przedmiot Twojego dziecka w szkole?",
      answers: [
        "🔬 Nauki ścisłe",
        "🎨 Sztuka i projektowanie",
        "🖥 Programowanie or informatyka",
        "📐 Matematyka",
        "💙 Lubi wszystkie przedmioty",
        "🫠 Nie jestem pewien/pewna",
      ],
    },
    2: {
      question: "Ile czasu dziennie Twoje dziecko spędza z gadżetami?",
      answers: [
        "🎮 Więcej niż 2 godziny",
        "🖥 Więcej niż 4 godziny",
        "📱 Więcej niż 6 godzin",
        "🙌 Nie wiem",
      ],
    },
  },
};

